module.exports = __webpack_public_path__ + "6dcb44540b1b8d835169a284894615b0.svg";